import {store} from "../../NextApp";

import {FETCH_PO_FOR_TYPE_SUCESS} from "../../constants/ActionTypes";

import axios from "util/Api";
import {fetchError, fetchStart, fetchSuccess} from "./Common";
import {message} from "antd";

export const getDataSuccess = ({ orders, spare, count }) => {
  // console.log(data);
  return {
    type: FETCH_PO_FOR_TYPE_SUCESS,
    datas: orders,
    resource: spare,
    count
  };
};

export const getPOAgainstType = (typeName, typeId, pageNo = 0) => {
  return async dispatch => {
    dispatch(fetchStart());

    const { poReport } = store.getState();
    axios
      .get(`/spare-part/purchase-history/${typeId}`)
      .then(result => {
        // console.log(result);
        dispatch(fetchSuccess());
        dispatch(getDataSuccess(result.data));
      })
      .catch(error => {
        // console.log(error);
        message.error(error.response.data.message);
        dispatch(fetchError(error.response.data.message));
        console.log("Error****:", error.response.data.message);
      });
  };
};
